import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Icon from '../Icon';
import styled from 'styled-components';

const SelectionBarContainer = styled(AppBar)`
  && {
    background: #000;
    color: #fff;
    width: auto;
  }
`;

const ClearIcon = styled(Icon)`
  && {
    color: #fff;
  }
`;

const BulkActionsContainer = styled.div`
  color: #fff;
  padding-right: ${props => props.theme.spacing()}px;

  .MuiIconButton-root,
  .MuiButton-root {
    color: #fff;
  }
`;

const SelectionLabel = styled(Typography)`
  && {
    font-weight: bold;
  }
`;

const SelectionBar = ({ bulkActions, selectionCount, onClearSelection }) => {
  const handleClearSelection = () => {
    if (onClearSelection) {
      onClearSelection();
    }
  };

  return (
    <SelectionBarContainer position="relative" color="default" elevation={0} square>
      <Toolbar disableGutters>
        <IconButton onClick={handleClearSelection}>
          <ClearIcon icon={['fal', 'times']} />
        </IconButton>
        <Box pl={1} pr={1} flexGrow={1}>
          <SelectionLabel variant="body1">{selectionCount}</SelectionLabel>
        </Box>
        {bulkActions && (
          <BulkActionsContainer>{bulkActions.map(action => action.render())}</BulkActionsContainer>
        )}
      </Toolbar>
    </SelectionBarContainer>
  );
};

SelectionBar.propTypes = {
  bulkActions: PropTypes.array,
  selectionCount: PropTypes.number,
  onClearSelection: PropTypes.func,
};

SelectionBar.defaultProps = {
  bulkActions: [],
  selectionCount: 0,
  onClearSelection: undefined,
};

export default SelectionBar;
